import { Form } from "react-bootstrap";
import { TreePicker } from "rsuite";

export default function InputSelectTree({
    value,
    label,
    name,
    error,
    touched,
    onChangeMethod,
    onBlurMethod,
    values,
    required,
    labelVal,
    valueVal,
    disabled,
    readOnly,
    createLink,
    createText,
    creatable,
    onCreate,
    renderMenu,
    disabledItemValues,
}: {
    value: string | number;
    label: string;
    name: string;
    error?: string;
    touched?: boolean;
    onChangeMethod: any;
    onBlurMethod?: any;
    values: Array<any>;
    required?: boolean;
    labelVal?: string;
    valueVal?: string;
    disabled?: boolean;
    readOnly?: boolean;
    createLink?: string;
    createText?: string;
    creatable?: boolean;
    onCreate?: any;
    renderMenu?: any;
    disabledItemValues?: Array<string> | Array<number>;
}) {
    return (
        <div className="mb-3">
            <Form.Label className="d-flex justify-content-between">
                <p className="m-0">
                    {label} {required && <span className="text-danger">*</span>}
                </p>
                <a href={createLink}>{createText}</a>
            </Form.Label>
            <TreePicker
                itemID={name}
                data={values}
                size="md"
                style={{ width: "100%", padding: 0 }}
                value={value}
                id={name}
                name={name}
                onChange={(value) => onChangeMethod({ target: { value, name } })}
                onBlur={onBlurMethod}
                className={
                    "form-control" +
                    (error !== undefined && touched !== undefined ? " is-invalid" : "")
                }
                appearance="subtle"
                placeholder="Seleccionar"
                disabled={disabled}
                readOnly={readOnly}
                renderMenu={renderMenu}
                valueKey={valueVal}
                labelKey={labelVal}
                disabledItemValues={disabledItemValues}
            />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </div>
    );
}
